import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps, Typography } from "@mui/material";
import { sxFormError } from "../../assets/styles/sxProps";
import DefaultText from "../typography/default-text";
import styles from './styles.module.css';
import { sxLargeTextTextField, sxTextField } from "./sxProps";

type TextFieldProps = MuiTextFieldProps & {
  errorMessage?: string;
  largeText?: boolean;
};

const TextField: React.FC<TextFieldProps> = ({ errorMessage, label, fullWidth, largeText, ...props }) => {

  return (
    <div className={styles['container-textfield']} style={{ width: fullWidth ? '100%' : 'fit-content' }}>
      {label &&
        <DefaultText lineHeight="13px" sx={{ color: 'black', fontSize: '16px', fontWeight: '600' }}>
          {label}
        </DefaultText>
      }

      <MuiTextField
        {...props}
        error={!!props.error}
        size="small"
        sx={largeText ? sxLargeTextTextField : sxTextField} />

      {!!props.error && <Typography sx={sxFormError}>{errorMessage}</Typography>}
    </div>
  );
};

export { TextField };

